import React, { useState, useRef, useEffect } from "react";
import { IoMdCloudUpload } from "react-icons/io";
import { AiOutlineDelete } from "react-icons/ai";
import "../../index.css";
import { useQuery, gql, useMutation } from "@apollo/client";
import axios from "axios";
import BackButton from "../CommonComponents/BackButton";

const GET_INVENTORY_LIST = gql`
  query {
    getInventoryCategory {
      status
      message
      categories {
        id
        name
      }
    }
  }
`;

const GET_CATEGORY = gql`
  query {
    getCategory {
      status
      message
      categoryList {
        id
        name
      }
    }
  }
`;

const ADD_SERVICE = gql`
  mutation addService($data: serviceInput!) {
    addService(data: $data) {
      status
      message
    }
  }
`;

const GET_PRODUCT = gql`
  query ($data: ID!) {
    getProductByCategoryId(data: $data) {
      status
      message
      products {
        id
        name
      }
    }
  }
`;
const GET_SERVICES = gql`
  query {
    getAdminService {
      services {
        id
        name
      }
    }
  }
`;

const ServiceForm = ({ setOpenServiceForm, duplicateFormData }) => {
  const {
    data: serviceData,
    loading: serviceloading,
    error: serviceerror,
  } = useQuery(GET_SERVICES);
  const {
    data: otherData,
    loading: otherLoading,
    error: otherError,
  } = useQuery(GET_CATEGORY);

  const {
    data: productData,
    loading: productLoading,
    error: productError,
    refetch,
  } = useQuery(GET_PRODUCT);

  const { loading, error, data } = useQuery(GET_INVENTORY_LIST);

  const [addService, { addLoading, addError }] = useMutation(ADD_SERVICE);
  const [name, setName] = useState(duplicateFormData ? `${duplicateFormData.name} Copy` : "");
  const [price, setPrice] = useState(duplicateFormData ? duplicateFormData.price : "");
  const [time, setTime] = useState(duplicateFormData ? duplicateFormData.time : "");
  const [category, setCategory] = useState(duplicateFormData ? duplicateFormData.serviceCategory?.id : "");
  const [subCategory, setSubCategory] = useState(duplicateFormData ? duplicateFormData.product?.id : "");

  const [image, setImage] = useState(duplicateFormData ? duplicateFormData.imageURL : null);
  const [productsUsed, setProductsUsed] = useState(
    duplicateFormData?.productsUsed?.length > 0
      ? duplicateFormData.productsUsed.map((p) => ({ name: p.name || "", imageUrl: p.imageUrl || "" }))
      : []
  );
  const [inventoryList, setInventoryList] = useState(() => {
    if (duplicateFormData && duplicateFormData.serviceChild) {
      let inventoryInfo = [];
      duplicateFormData.serviceChild.forEach((item) => {
        if (item.serviceInventory) {
          inventoryInfo.push({
            inventoryId: item.serviceInventory.id,
            price: item.price,
            alternateGroupId: item.alternateGroupId || "",
          });
        }
      });
      if (inventoryInfo.length > 0) return inventoryInfo;
    }
    return [{ inventoryId: "", price: "", alternateGroupId: "" }];
  });
  const [dataList, setDataList] = useState([]);
  const [dataCategoryList, setDataCategoryList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [isFetched, setIsFetched] = useState(false);
  const [description, SetDesciption] = useState(duplicateFormData ? duplicateFormData.description : "");
  const [gender, setGender] = useState(duplicateFormData ? duplicateFormData.gender : "");
  const [cutPrice, setCutPrice] = useState(duplicateFormData ? duplicateFormData.cutPrice : "");
  const [quick_price, setquick_price] = useState(duplicateFormData ? duplicateFormData.quickPrice : "");
  // const [coupon, setCoupon] = useState("");
  const [serviceList, setServiceList] = useState([]);
  let [freeService, setFreeService] = useState(duplicateFormData ? duplicateFormData.freeService : "");
  const [recommendServiceList, setrecommendServiceList] = useState(duplicateFormData?.recommendations ? duplicateFormData.recommendations : [""]);
  const [shortDescription, setshortDescription] = useState(duplicateFormData ? duplicateFormData.shortDescription : "");
  const [specialPrice, setspecialPrice] = useState(duplicateFormData ? duplicateFormData.specialPrice : "");
  const [campaignPrice, setCampaignPrice] = useState(duplicateFormData?.campaignPrice ?? "");
  const [campaignStartAt, setCampaignStartAt] = useState(
    duplicateFormData?.campaignStartAt ? duplicateFormData.campaignStartAt.substring(0, 10) : ""
  );
  const [campaignEndAt, setCampaignEndAt] = useState(
    duplicateFormData?.campaignEndAt ? duplicateFormData.campaignEndAt.substring(0, 10) : ""
  );
  const [campaignLabel, setCampaignLabel] = useState(duplicateFormData?.campaignLabel ?? "");
  const [details, setdetails] = useState(duplicateFormData ? duplicateFormData.details : "");
  const fileInputRef = useRef(null);
  const [displayOrder, setDisplayOrder] = useState(duplicateFormData ? duplicateFormData.displayOrder : "");
  const [isPackage, setIsPackage] = useState(duplicateFormData ? duplicateFormData.isPackage : false);
  const [allowTimeBypass, setAllowTimeBypass] = useState(duplicateFormData ? duplicateFormData.allowTimeBypass : false);
  const [requiresTimerVerification, setRequiresTimerVerification] = useState(duplicateFormData ? duplicateFormData.requiresTimerVerification : false);
  const [selectionCount, setSelectionCount] = useState(duplicateFormData?.selectionCount || "");
  const [inventoryGenerationMode, setInventoryGenerationMode] = useState(duplicateFormData?.inventoryGenerationMode || "ON_BOOKING");
  const [packageChildServiceIds, setPackageChildServiceIds] = useState(
    duplicateFormData?.packageChildServices?.length > 0 
      ? duplicateFormData.packageChildServices.map(s => s.id) 
      : [""]
  );

  const [metaData, setMetaData] = useState(() => {
    if (!duplicateFormData) return {};
    try {
      return typeof duplicateFormData.metaData === "string"
        ? JSON.parse(duplicateFormData.metaData)
        : duplicateFormData.metaData || {};
    } catch {
      return {};
    }
  });

  const [metaDataInput, setMetaDataInput] = useState(
    JSON.stringify(metaData, null, 2)
  );

  useEffect(() => {
    try {
      if (duplicateFormData && duplicateFormData.serviceCategory) {
        refetch({ data: duplicateFormData.serviceCategory.id })
          .then((res) => {
            if (res.data.getProductByCategoryId.status === "SUCCESS") {
              setProductList(res.data.getProductByCategoryId.products);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
      
      console.log("category List is is");
      console.log(otherData);

      setDataCategoryList(otherData.getCategory.categoryList);
      setDataList(data.getInventoryCategory.categories);
      setServiceList(serviceData.getAdminService.services);
      setIsFetched(true);
    } catch (err) {
      console.log(err);
    }
  }, [data, serviceData]);

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    // setLicenseImage(file);
    e.preventDefault();
    const url = `https://api.barbera.in/img/upload`;
    try {
      const formData = new FormData();

      formData.append("file", file);

      const { data } = await axios.post(url, formData);
      console.log(data);
      if (data.success === true) {
        setImage(data.url);
        // setLicenseImage(data.url);
      }
    } catch (error) {
      console.error(error);
      window.alert(error.message + " Try Again");
      // history.push("/dashboard/compliance");
    }
  };

  const handleAddProductUsed = () => {
    setProductsUsed([...productsUsed, { name: "", imageUrl: "" }]);
  };

  const handleRemoveProductUsed = (index) => {
    const updatedList = [...productsUsed];
    updatedList.splice(index, 1);
    setProductsUsed(updatedList);
  };

  const handleProductUsedNameChange = (index, event) => {
    const updatedList = [...productsUsed];
    updatedList[index] = { ...updatedList[index], name: event.target.value };
    setProductsUsed(updatedList);
  };

  const handleProductUsedImageUpload = async (index, e) => {
    const file = e.target.files[0];
    if (!file) return;
    const url = `https://api.barbera.in/img/upload`;
    try {
      const formData = new FormData();
      formData.append("file", file);
      const { data } = await axios.post(url, formData);
      if (data.success === true) {
        const updatedList = [...productsUsed];
        updatedList[index] = { ...updatedList[index], imageUrl: data.url };
        setProductsUsed(updatedList);
      }
    } catch (error) {
      console.error(error);
      window.alert(error.message + " Try Again");
    }
  };

  const handleRemoveRow1 = (index) => {
    const updatedList = [...recommendServiceList];
    updatedList.splice(index, 1);
    setrecommendServiceList(updatedList);
  };

  const handleAddRow1 = () => {
    setrecommendServiceList([...recommendServiceList, ""]);
    console.log([...recommendServiceList, ""]);
  };
  const handleRecommendChange = (index, event) => {
    const { name, value } = event.target;
    const updatedList = [...recommendServiceList];
    updatedList[index] = value;
    setrecommendServiceList(updatedList);
  };

  const handleRemovePackageChild = (index) => {
    const updatedList = [...packageChildServiceIds];
    updatedList.splice(index, 1);
    setPackageChildServiceIds(updatedList);
  };

  const handleAddPackageChild = () => {
    setPackageChildServiceIds([...packageChildServiceIds, ""]);
  };

  const handlePackageChildChange = (index, event) => {
    const { value } = event.target;
    const updatedList = [...packageChildServiceIds];
    updatedList[index] = value;
    setPackageChildServiceIds(updatedList);
  };

  const handleBrowseClick = (e) => {
    fileInputRef.current.click();
  };

  const handleInventoryChange = (index, event) => {
    const { name, value } = event.target;
    const updatedList = [...inventoryList];
    updatedList[index][name] = value;
    setInventoryList(updatedList);
  };

  const handleInventoryPriceChange = (index, event) => {
    const { name, value } = event.target;
    const updatedList = [...inventoryList];
    updatedList[index][name] = parseInt(value);
    setInventoryList(updatedList);
  };

  const handleRemoveRow = (index) => {
    const updatedList = [...inventoryList];
    updatedList.splice(index, 1);
    setInventoryList(updatedList);
  };

  const handleAddRow = () => {
    setInventoryList([
      ...inventoryList,
      { inventoryId: "", price: "", alternateGroupId: "" },
    ]);
  };

  const onCategoryChange = (e) => {
    setCategory(e.target.value);
    console.log(e.target.value);
    refetch({ data: e.target.value })
      .then((res) => {
        console.log("onCategoryChange hitted");
        console.log(res);
        if (res.data.getProductByCategoryId.status === "SUCCESS") {
          //   window.location.reload();
          setProductList(res.data.getProductByCategoryId.products);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("submit is hitted");
    let finalDataObj = {};

    const cleanedList = recommendServiceList.filter(
      (service) => service !== "" && service !== "none"
    );

    if (freeService === "" || freeService === "none") {
      freeService = null;
    }
    finalDataObj.name = name;
    finalDataObj.imageURL = image;
    finalDataObj.price = parseInt(price);
    finalDataObj.productId = subCategory;
    finalDataObj.description = description;
    finalDataObj.inventoryList = inventoryList;
    finalDataObj.categoryId = category;

    finalDataObj.time = parseInt(time);
    finalDataObj.gender = gender;
    finalDataObj.cutPrice = parseInt(cutPrice);
    finalDataObj.quickPrice = parseInt(quick_price);
    finalDataObj.freeService = freeService;
    finalDataObj.recommendations = cleanedList;
    finalDataObj.shortDescription = shortDescription;
    finalDataObj.specialPrice = parseInt(specialPrice);
    finalDataObj.campaignPrice = campaignPrice ? parseInt(campaignPrice) : null;
    finalDataObj.campaignStartAt = campaignStartAt || null;
    finalDataObj.campaignEndAt = campaignEndAt || null;
    finalDataObj.campaignLabel = campaignLabel;
    finalDataObj.details = details;
    finalDataObj.metaData = metaData;
    finalDataObj.displayOrder = parseInt(displayOrder);
    
    finalDataObj.isPackage = isPackage;
    finalDataObj.allowTimeBypass = allowTimeBypass;
    finalDataObj.requiresTimerVerification = requiresTimerVerification;
    finalDataObj.selectionCount = parseInt(selectionCount) || 0;
    finalDataObj.inventoryGenerationMode = inventoryGenerationMode;
    finalDataObj.packageChildServiceIds = packageChildServiceIds.filter(
      (id) => id !== "" && id !== "none"
    );
    finalDataObj.productsUsed = productsUsed
      .filter((p) => p.name.trim() !== "" || p.imageUrl)
      .map((p) => ({ name: p.name, imageUrl: p.imageUrl }));

    console.log(finalDataObj);
    addService({
      variables: {
        data: finalDataObj,
      },
    })
      .then((res) => {
        console.log("add service res is");
        console.log(res);
        if (res.data.addService.status === "SUCCESS") {
          window.location.reload();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const subCategoryClass = subCategory ? "text-white" : " text-[#9A9A9A]";
  const categoryClass = category ? "text-white" : " text-[#9A9A9A]";

  return (
    <div>
      {isFetched && (
        <div className="flex flex-col py-3 px-2 space-y-5">
          <BackButton onClick={() => setOpenServiceForm(false)} />
          <h3 className="text-[#FBB033] font-be-jost-pro font-bold text-2xl">
            Add Service
          </h3>
          <div className="w-full flex flex-col space-y-8">
            <input
              type="text"
              placeholder="Name*"
              className="px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none text-white"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <input
              type="text"
              placeholder="Price*"
              className="px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none text-white"
              value={price}
              onChange={(e) => setPrice(e.target.value)}
            />
            <input
              type="text"
              placeholder="Time*"
              className="px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none text-white"
              value={time}
              onChange={(e) => setTime(e.target.value)}
            />
            <input
              type="text"
              placeholder="details*"
              className="px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none text-white"
              value={details}
              onChange={(e) => setdetails(e.target.value)}
            />
            <select
              className={`px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none ${categoryClass}`}
              value={category}
              // onChange={(e) => setCategory(e.target.value)}
              onChange={onCategoryChange}
            >
              <option value="" disabled hidden>
                Category*
              </option>
              {/* <option value="men">Men</option>
          <option value="women">Women</option> */}
              {dataCategoryList.map((item, i) => (
                <option value={item.id}>{item.name}</option>
              ))}
            </select>
            <select
              className={`px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none ${subCategoryClass}`}
              value={subCategory}
              onChange={(e) => setSubCategory(e.target.value)}
            >
              <option value="" disabled selected hidden>
                Sub-Category*
              </option>
              {/* <option value="hair">hair</option>
          <option value="beard">beard</option>
          <option value="spa">spa</option>
          <option value="nail">nail</option> */}
              {productList.length > 0 &&
                productList.map((item, i) => (
                  <option value={item.id}>{item.name}</option>
                ))}
            </select>
            <div className="flex items-center">
              <input
                id="image-upload"
                type="file"
                ref={fileInputRef}
                className="hidden"
                onChange={handleImageUpload}
              />
              <input
                type="text"
                placeholder="Upload Image*"
                disabled={true}
                className="w-4/5 px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none text-white"
              />
              <IoMdCloudUpload
                className="text-[#9A9A9A] text-3xl"
                onClick={handleBrowseClick}
              />
              <p className="ml-3 font-be-jost-pro text-[#FBB033] font-normal text-base cursor-pointer">
                Mark as Primary
              </p>
            </div>

            <div className="flex flex-col space-y-4 p-4 border border-[#FBB033] rounded-md">
              <h4 className="text-[#FBB033] font-be-jost-pro font-bold text-lg">
                Products Used
              </h4>
              <p className="text-[#9A9A9A] text-sm">
                Add the products used for this service - shown to the customer so they know what to expect.
              </p>
              {productsUsed.map((product, index) => (
                <div className="flex items-center space-x-2 lg:space-x-8" key={index}>
                  <input
                    type="text"
                    placeholder="Product name (e.g. XYZ Shampoo)"
                    className="px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none text-white w-1/2 lg:w-[35%]"
                    value={product.name}
                    onChange={(e) => handleProductUsedNameChange(index, e)}
                  />
                  <input
                    id={`product-used-image-${index}`}
                    type="file"
                    className="hidden"
                    onChange={(e) => handleProductUsedImageUpload(index, e)}
                  />
                  <label htmlFor={`product-used-image-${index}`} className="cursor-pointer">
                    <IoMdCloudUpload className="text-[#9A9A9A] text-3xl" />
                  </label>
                  {product.imageUrl && (
                    <img
                      src={`https://api.barbera.in${product.imageUrl}`}
                      alt={product.name}
                      className="w-10 h-10 object-cover rounded"
                    />
                  )}
                  <AiOutlineDelete
                    className="text-[#FBB033] text-2xl cursor-pointer"
                    onClick={() => handleRemoveProductUsed(index)}
                  />
                </div>
              ))}
              <span
                className="text-[#FBB033] font-be-jost-pro text-base font-normal cursor-pointer"
                onClick={handleAddProductUsed}
              >
                {`Add Product +`}
              </span>
            </div>

            <select
              className={`px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none ${categoryClass}`}
              value={gender}
              // onChange={(e) => setCategory(e.target.value)}
              onChange={(e) => setGender(e.target.value)}
            >
              <option value="" disabled hidden>
                Gender*
              </option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
            </select>
            {/* <div className="w-full"> */}
            {inventoryList.map((inventory, index) => {
              return (
                <div className="flex space-x-2 lg:space-x-8" key={index}>
                  <select
                    className={`px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none ${inventory.inventoryId === ""
                        ? " text-[#9A9A9A]"
                        : "text-white"
                      } w-1/2 lg:w-[25%]`}
                    value={inventory.inventoryId}
                    onChange={(e) => handleInventoryChange(index, e)}
                    name="inventoryId"
                  >
                    <option value="" disabled hidden>
                      Inventory*
                    </option>
                    {/* <option value="Hair Cutting Kit">Hair Cutting Kit</option>
                <option value="Hair Color Kit">Hair Color Kit</option> */}
                    {dataList.map((item, i) => (
                      <option value={item.id} key={i}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                  <div className="flex items-center">
                    <span
                      className="text-[#FBB033] font-be-jost-pro text-base font-normal cursor-pointer"
                      onClick={handleAddRow}
                    >
                      {`Add Inventory +  `}
                    </span>
                    {inventoryList.length !== 1 && (
                      <AiOutlineDelete
                        className="text-[#FBB033] text-2xl cursor-pointer"
                        onClick={() => handleRemoveRow(index)}
                      />
                    )}
                  </div>
                  <input
                    type="number"
                    placeholder="Amount*"
                    className="px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none text-white w-1/3"
                    value={inventory.price}
                    onChange={(event) =>
                      handleInventoryPriceChange(index, event)
                    }
                    name="price"
                  />
                  <input
                    type="text"
                    placeholder="Alternate group (optional)"
                    title="Rows with the same tag become interchangeable alternates - the employee picks one at start of service."
                    className="px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none text-white w-1/3"
                    value={inventory.alternateGroupId || ""}
                    onChange={(event) =>
                      handleInventoryChange(index, event)
                    }
                    name="alternateGroupId"
                  />
                </div>
              );
            })}

            {recommendServiceList.map((service, index) => {
              console.log("Tanish -----------------------");
              console.log(service);

              let serviceName = "";
              if (service.length !== 0) {
                for (let i = 0; i < serviceList.length; i++) {
                  if (service === serviceList[i].id) {
                    serviceName = serviceList[i].id;
                    console.log("serviceName", serviceName);
                  }
                }
              }

              return (
                <div className="flex space-x-2 lg:space-x-8" key={index}>
                  <select
                    className={`px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none ${serviceName === "" ? "text-[#9A9A9A]" : "text-white"
                      } w-1/2 lg:w-[25%]`}
                    value={serviceName} // Ensure it is empty initially
                    onChange={(e) => handleRecommendChange(index, e)}
                    name="service"
                  >
                    <option value="" disabled>
                      Select Service
                    </option>
                    <option value="none">None</option>{" "}
                    {/* Default None Option */}
                    {serviceList.map((item, i) => (
                      <option value={item.id} key={i}>
                        {item.name}
                      </option>
                    ))}
                  </select>

                  <div className="flex items-center">
                    <span
                      className="text-[#FBB033] font-be-jost-pro text-base font-normal cursor-pointer"
                      onClick={handleAddRow1}
                    >
                      {`Add RecommendService +  `}
                    </span>
                    {recommendServiceList.length >= 2 && (
                      <AiOutlineDelete
                        className="text-[#FBB033] text-2xl cursor-pointer"
                        onClick={() => handleRemoveRow1(index)}
                      />
                    )}
                  </div>
                </div>
              );
            })}

            <input
              type="text"
              placeholder="Description*"
              className="px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none text-white"
              value={description}
              onChange={(e) => SetDesciption(e.target.value)}
            />
            <input
              type="text"
              placeholder="ShortDescription*"
              className="px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none text-white"
              value={shortDescription}
              onChange={(e) => setshortDescription(e.target.value)}
            />

            <input
              type="number"
              placeholder="Cutprice*"
              className="px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none text-white"
              value={cutPrice}
              onChange={(e) => setCutPrice(e.target.value)}
            />
            <input
              type="number"
              placeholder="Quick_price*"
              className="px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none text-white"
              value={quick_price}
              onChange={(e) => setquick_price(e.target.value)}
            />
            <input
              type="number"
              placeholder="Special_Price*"
              className="px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none text-white"
              value={specialPrice}
              onChange={(e) => setspecialPrice(e.target.value)}
            />

            <input
              type="number"
              placeholder="Campaign Price"
              className="px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none text-white"
              value={campaignPrice}
              onChange={(e) => setCampaignPrice(e.target.value)}
            />
            <input
              type="text"
              placeholder="Campaign Label (e.g. MONSOON OFFER)"
              className="px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none text-white"
              value={campaignLabel}
              onChange={(e) => setCampaignLabel(e.target.value)}
            />
            <label className="text-[#9A9A9A] text-sm">Campaign Start</label>
            <input
              type="date"
              className="px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none text-white"
              value={campaignStartAt}
              onChange={(e) => setCampaignStartAt(e.target.value)}
            />
            <label className="text-[#9A9A9A] text-sm">Campaign End</label>
            <input
              type="date"
              className="px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none text-white"
              value={campaignEndAt}
              onChange={(e) => setCampaignEndAt(e.target.value)}
            />

            <select
              className={`px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none ${categoryClass}`}
              value={freeService}
              onChange={(e) => setFreeService(e.target.value)}
            >
              <option value="" disabled hidden>
                Select Service*
              </option>
              <option value="none">None</option>
              {serviceList.map((item, i) => (
                <option key={i} value={item.id}>
                  {item.name}
                </option>
              ))}
            </select>
            <input
              type="number"
              placeholder="Display Order*"
              className="px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none text-white"
              value={displayOrder}
              onChange={(e) => setDisplayOrder(e.target.value)}
            />

            <div className="flex items-center space-x-2">
              <input
                type="checkbox"
                id="isPackage"
                checked={isPackage}
                onChange={(e) => setIsPackage(e.target.checked)}
                className="w-5 h-5 cursor-pointer"
              />
              <label htmlFor="isPackage" className="text-white text-lg font-be-jost-pro cursor-pointer">
                Is this a Package?
              </label>
            </div>

            <div className="flex items-center space-x-2 mt-4">
              <input
                type="checkbox"
                id="allowTimeBypass"
                checked={allowTimeBypass}
                onChange={(e) => setAllowTimeBypass(e.target.checked)}
                className="w-5 h-5 cursor-pointer"
              />
              <label htmlFor="allowTimeBypass" className="text-white text-lg font-be-jost-pro cursor-pointer">
                Allow Time Bypass (Add-on Conflicts)
              </label>
            </div>

            <div className="flex items-center space-x-2 mt-4">
              <input
                type="checkbox"
                id="requiresTimerVerification"
                checked={requiresTimerVerification}
                onChange={(e) => setRequiresTimerVerification(e.target.checked)}
                className="w-5 h-5 cursor-pointer"
              />
              <label htmlFor="requiresTimerVerification" className="text-white text-lg font-be-jost-pro cursor-pointer">
                Requires Timer Verification (customer confirms start, live countdown shown on both apps)
              </label>
            </div>


            {isPackage && (
              <div className="flex flex-col space-y-6 p-4 border border-[#FBB033] rounded-md">
                <h4 className="text-[#FBB033] font-be-jost-pro font-bold text-lg">Package Configuration</h4>
                
                <input
                  type="number"
                  placeholder="Selection Count (e.g., Pick Any 3)*"
                  className="px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none text-white"
                  value={selectionCount}
                  onChange={(e) => setSelectionCount(e.target.value)}
                />

                <select
                  className={`px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none text-white`}
                  value={inventoryGenerationMode}
                  onChange={(e) => setInventoryGenerationMode(e.target.value)}
                >
                  <option value="ON_BOOKING">ON BOOKING (Fixed Bundle)</option>
                  <option value="ON_SELECTION">ON SELECTION (Dynamic Pick-Any)</option>
                </select>

                <div className="flex flex-col space-y-4">
                  <p className="text-white text-sm">Select Child Services for this Package:</p>
                  {packageChildServiceIds.map((service, index) => {
                    return (
                      <div className="flex space-x-2 lg:space-x-8" key={index}>
                        <select
                          className={`px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none ${service === "" ? "text-[#9A9A9A]" : "text-white"} w-1/2 lg:w-[25%]`}
                          value={service}
                          onChange={(e) => handlePackageChildChange(index, e)}
                        >
                          <option value="" disabled>Select Child Service</option>
                          <option value="none">None</option>
                          {serviceList && serviceList.map((item, i) => (
                            <option value={item.id} key={i}>
                              {item.name}
                            </option>
                          ))}
                        </select>

                        <div className="flex items-center">
                          <span
                            className="text-[#FBB033] font-be-jost-pro text-base font-normal cursor-pointer"
                            onClick={handleAddPackageChild}
                          >
                            Add Child Service +
                          </span>
                          {packageChildServiceIds.length >= 2 && (
                            <AiOutlineDelete
                              className="text-[#FBB033] text-2xl cursor-pointer ml-4"
                              onClick={() => handleRemovePackageChild(index)}
                            />
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}

            <textarea
              placeholder='{"services": ["facial", "cleanup"]}'
              className="px-2 py-1 bg-[#0c0b0b] border-b border-b-[#E0E0E0] outline-none text-white w-full h-32"
              value={metaDataInput}
              onChange={(e) => {
                const input = e.target.value;
                setMetaDataInput(input); // ALWAYS update UI

                try {
                  const parsed = JSON.parse(input);
                  setMetaData(parsed); // update only if valid
                } catch {
                  // do nothing → allow typing
                }
              }}
            />

            <div className="flex items-center justify-center">
              <button
                className="bg-[#FBB034] text-[#202125] py-2 px-6 rounded-md font-poppins text-sm font-bold"
                onClick={handleSubmit}
              >
                Add Service
              </button>
            </div>
            {/* </div> */}
          </div>
        </div>
      )}
    </div>
  );
};

export default ServiceForm;
